module.exports = __webpack_public_path__ + "static/media/em-115.4dc76e7c.png";